var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"router",attrs:{"to":{ name: 'list' }}},[_c('button',{staticClass:"nav-btn"},[_vm._v(" LISTS"),_c('span',{attrs:{"id":"my-lists"}},[_vm._v(_vm._s(_vm.count))])])])}
var staticRenderFns = []

export { render, staticRenderFns }